import { computed } from "vue";
import { useModifiers } from "./useModifiers";

export const sizePropNames = ["size", "sizeSm", "sizeMd"];
export const sizePropValues = [
  "micro",
  "xxx-small",
  "xx-small",
  "x-small",
  "small",
  "medium",
  "large",
  "x-large",
  "xx-large",
  "xxx-large",
  "display",
  "x-display",
];

export const sizeProps = sizePropNames.reduce(sizePropsAccumulator, {});

function sizePropsAccumulator(acc, property) {
  return {
    ...acc,
    ...createSizeProp(property),
  };
}

function createSizeProp(property) {
  return {
    [property]: {
      type: String,
      default: undefined,
      validator: (value) => sizePropValues.includes(value),
    },
  };
}

export function useSize(props) {
  const { modifiers } = useModifiers(props, ...sizePropNames);
  const sizeModifiers = computed(() => modifiers.value);

  return {
    sizeModifiers,
  };
}
